import { render, staticRenderFns } from "./PrivacyText.vue?vue&type=template&id=0ebdbc2e&"
import script from "./PrivacyText.vue?vue&type=script&lang=ts&"
export * from "./PrivacyText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports